<template>
    <div>
        <div class="content-wrapper">
            <div class="row">
                <div class="col-sm-12 col-md-6">
                    <app-breadcrumb :page-title="$t('product_type_conditions')" :directory="$t('list')" :icon="'grid'" />
                </div>
                <div class="col-sm-12 col-md-6 breadcrumb-side-button">
                    <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
                        <button 
                            @click=" addCondition = true, list = false"
                            type="button" class="btn btn-primary btn-with-shadow">
                            {{ $t('add_product_condition') }}
                        </button>
                    </div>
                </div>
            </div>
            <app-table :id="tableId" :options="options" @action="getListAction" :selected-url="selectedUrl" />
        </div>
        <AddCondition 
            v-if="addCondition"
            @close="addCondition = false"
            @save="handleSaveCondition" />
 
        <app-delete-modal 
            v-if="deleteConfirmationModalActive" 
            :preloader="deleteLoader" 
            modal-id="demo-delete"
            @confirmed="confirmed" 
            @cancelled="cancelled" />

        <EditDetail
            v-if="editDetail"
            :id="this.rowData.id"
            @close="editDetail = false"
            @save="handleUpdateDetail" />    

        <AddProductType  
            v-if="addProductType"
            @close="addProductType = false"
            @save="handleSaveProductType" />    

    </div>
</template>

<script>
import configTable from "./mixins/configTable";
import * as actions from "../../../Config/ApiUrl.js";
import { FormMixin } from '../../../../core/mixins/form/FormMixin.js';
import CoreLibrary from "../../../../core/helpers/CoreLibrary.js";
import AddCondition from "./AddCondition.vue";
import EditDetail from "./EditDetail.vue";
import { tableConditions } from './mixins/tableConditions.js';
import { saveCondition, deleteDetail, updateDetail, saveProductType } from "./api/api";
import AddProductType from './AddProductType.vue';

export default {
    extends: CoreLibrary,
    mixins: [tableConditions, FormMixin],
    components :{
        AddCondition, EditDetail, AddProductType
    },  
    data() {
        return {
            tableId: 'advance-table',
            options: configTable,
            addCondition : false,
            addDetail : false,
            editDetail : false,
            deleteConfirmationModalActive: false,
            deleteLoader: false,
            addProductType : false,
            rowData: {},
        }
    },
    created() {
        this.options.columns = this.tableColumns; // Asignar las columnas de la tabla
    },
    methods : {
        getListAction(rowData, actionObj, active) {
            this.rowData = rowData;
            if (actionObj.title === 'Delete') {
                this.openDeleteModal();
            }
            if (actionObj.title === 'Edit') {
                this.openEditModal();
            }
        },  

        async handleSaveCondition(condition, control, description){
            const res = await saveCondition(condition, control, description);
            if (res.created) {
                this.$toastr.s(res.message);
                this.addCondition = false;
                location.reload();
                return;
            }else {
                this.$toastr.e(res.message);
                return;
            }

        },

        openDeleteModal() {
            this.deleteConfirmationModalActive = true;
        },

        cancelled() {
            this.deleteConfirmationModalActive = false;
            location.reload();
        },

        async confirmed() {
            const id = this.rowData.id;
            const res = await deleteDetail(id);
            if (res.deleted) {
                $("#demo-delete").modal('hide');
                this.$toastr.s(res.message);
                this.cancelled();
                return;
            }
            this.$toastr.e(res.message);
        },

        openEditModal() {
            this.editDetail = true;
        },

        async handleSaveProductType(data){
            const res = await saveProductType(data);
            if (res.created) {
                this.$toastr.s(res.message);
                this.addCountry = false;
                return;
            }
            this.$toastr.e(res.message);
        },

        async handleUpdateDetail(data){
            const id = this.rowData.id;
            const res = await updateDetail(id, data);
            if (res.updated) {
                this.$toastr.s(res.message);
                this.editCity = false;
                location.reload();
                return;
            }
            this.$toastr.e(res.message);
        }
    },
}
    
</script>

